<template>
    <nav class="navbar navbar-default navbar-light bg-light border-bottom shadow-sm mb-5" >
        <div class="mr-auto">
            <span v-show="currentUser.email"></span>
        </div>

        <ul class="navbar-nav d-flex flex-row">
            <!-- <li v-show="!user" class="nav-item">
                <router-link to="/login" class="nav-link mr-5">Login</router-link>
            </li> -->
            <li v-show="currentUser.admin || currentUser.manager || currentUser.editor || currentUser.super" class="nav-item">
                <router-link to="/dashboard" class="nav-link mr-5">Dashboard</router-link>
            </li>
            <li v-show="currentUser.admin || currentUser.manager" class="nav-item">
                <router-link to="/profile" class="nav-link mr-5">Perfil</router-link>
            </li>
            <li v-show="currentUser.email" class="nav-item">
                <a @click="signoutButtonPressed" class="nav-link mr-5">Logout</a>
            </li>
        </ul>
    </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import firebase from "firebase/app"
import 'firebase/app'
import "firebase/auth"
import "firebase/firestore"

export default {
    data() {
        return {
            user: null,
            dashboard: false
        };
    },
    created() {
        firebase.auth().onAuthStateChanged(user => {
            this.user = user
            this.getPrivileges()
        })
    },
    computed: {
        ...mapGetters(['currentUser'])
    },
    methods: {
        ...mapActions({
            getActiveUser: 'getActiveUser'
        }),
        signoutButtonPressed(e) {
            e.stopPropagation()
            firebase.auth().signOut()
            this.$router.push({ name: "Login" })
            this.$store.commit("cleanActiveUser")
        },
        async getPrivileges() {
            if (firebase.auth().currentUser) {
                await this.getActiveUser()
            }
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/NavBar.vue